module.exports = __webpack_public_path__ + "img/wyfw_h.ce021aaa.png";